import { render } from "./sliderProducts.vue?vue&type=template&id=39ef3b56"
import script from "./sliderProducts.vue?vue&type=script&lang=js"
export * from "./sliderProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__